import { Banner, Button } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { dacConstants } from 'locale/deviceAccessControl'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HashLink } from 'react-router-hash-link'
import styled from 'styled-components'
import { DEVICES_SETTINGS_PAGE_WITH_HASH } from '../../types'

type Props = {
  title?: string
  testId?: string
}

const PreferencesBanner: FC<Props> = ({ title, testId }) => {
  const { t } = useTranslation(NAMESPACE.DEVICE_ACCESS_CONTROL)

  return (
    <Banner
      color={colours.category.clinicalCare}
      testId={testId}
      text={
        <EmptyStateWrapper>
          <TextStyled>
            {title || t(dacConstants.YOU_HAVENT_ENABLED_DAC)}
          </TextStyled>
          <HashLink to={DEVICES_SETTINGS_PAGE_WITH_HASH} smooth>
            <StyledNavigateButton variant="text" data-cy="btn-preferences">
              {t(dacConstants.PREFERENCES)}
            </StyledNavigateButton>
          </HashLink>
        </EmptyStateWrapper>
      }
    />
  )
}

const TextStyled = styled(Text)`
  color: initial;
`

const EmptyStateWrapper = styled.div`
  display: flex;
`

const StyledNavigateButton = styled(Button)`
  margin-left: 4px;
  margin-right: 4px;
`

export default PreferencesBanner
